<template>
  <listview :vm="listVm" />
</template>

<script>
  import Listview from '@/components/base/Listview';
  import ListVm from '@/components/base/ListVm';
  import Router from '@/router';
  import Format from '@/format';

  const _comp = {
    name: 'Pakbonnen',
    data: () => ({
      listVm: null
    }),
    created() {
      this.listVm = new ListVm(
        'Pakbonnen',
        'Posting_Date desc',
        (ctx) => `/odata/PostedSalesShipment?$filter=Posting_Date ge ${ctx.year}-01-01T00:00:00Z and Posting_Date le ${ctx.year}-12-31T23:59:59Z`,
        ['Posting_Date'],
        (srch, items) => items.filter(i => `${i.No}${i.Order_No}${i.Your_Reference}${i.External_Document_No}`.toLowerCase().indexOf(srch.toLowerCase()) != -1),
        (item) => Router.push('/Pakbon/' + item.No),
        [
/////////////////////////////////
/////////////////////////////////////////////////////////
////////////////////
          { name: 'Ordernummer', sort: 'Order_No', select: i => i.Order_No },
          { name: 'Orderklantnr.', sort: 'Sell_to_Customer_No', select: i => i.Sell_to_Customer_No },
          { name: 'Naam', sort: 'Sell_to_Customer_Name', select: i => i.Sell_to_Customer_Name },
          { name: 'Verzenddatum', sort: 'Posting_Date', select: i => Format.date(i.Posting_Date) },
/////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////
////////////////////
          { name: 'Extern documentnr', sort: 'External_Document_No', select: i => i.External_Document_No },
        ]
      );
    },
    components: {
      'listview': Listview
    }
  };

  export default _comp;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Pakbonnen.vue